import React from 'react';

/**
 * Liste de clients cliquable (pas de <select>) : un clic sélectionne,
 * un second clic désélectionne. Les clients sont ordonnés par activité
 * la plus récente.
 *
 * @param {Array<{name: string, count: number}>} clients
 * @param {string|null} value  nom du client sélectionné
 * @param {(name: string|null) => void} onChange
 */
export default function ClientFilter({ clients, value, onChange, total, label = 'Filtrer par client' }) {
  if (!clients || clients.length === 0) return null;

  return (
    <div className="ta-chipbar" role="group" aria-label={label}>
      <div className="ta-chipbar-label">{'// '}{label}</div>

      <button
        type="button"
        className={`ta-chip ${!value ? 'is-active' : ''}`}
        onClick={() => onChange(null)}
        aria-pressed={!value}
      >
        <span className="t">Tous</span>
        {typeof total === 'number' && <span className="n">{total}</span>}
      </button>

      {clients.map((c) => {
        const active = value === c.name;
        return (
          <button
            key={c.name}
            type="button"
            className={`ta-chip ${active ? 'is-active' : ''}`}
            onClick={() => onChange(active ? null : c.name)}
            aria-pressed={active}
            title={c.name}
          >
            <span className="t">{c.name}</span>
            <span className="n">{c.count}</span>
          </button>
        );
      })}
    </div>
  );
}
